export class ConnectGcpOrganizationResponse {
    'gcpOrganization';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "gcpOrganization",
            "baseName": "gcpOrganization",
            "type": "GcpOrganization",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ConnectGcpOrganizationResponse.attributeTypeMap;
    }
    constructor() {
    }
}
